import React, { useState, useEffect, useRef } from "react";
import { Container, Row, Col, Nav } from "react-bootstrap";
import { NavLink, Outlet, useNavigate } from "react-router-dom";
import { getImage } from "../../utils/admin/misc";
import "../../css/admin/sidebar.css";
import { FiUserPlus, FiUsers, FiLink, FiLogOut } from "react-icons/fi";
import { FaPaperPlane, FaBook } from "react-icons/fa";
import { BsPrinter, BsClipboardCheck, BsLock } from "react-icons/bs";
import Swal from "sweetalert2";
import Loader from "../loader";

const SidebarLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [showLoader, setShowLoader] = useState(false);
  const companyName = localStorage.getItem("cn") || "";
  const companyLogo = localStorage.getItem("lo") || "";
  const sidebarRef = useRef(null);
  const navigate = useNavigate();
  let userType = JSON.parse(localStorage.getItem("ut"));
  let userFname = localStorage.getItem("fn");
  let userLname = localStorage.getItem("ln");

  const toggleSidebar = () => {
    setSidebarOpen((prev) => !prev);
  };

  const closeSidebar = () => {
    setSidebarOpen(false);
  };

  useEffect(() => {
    const handleClickOutside = (event) => {
      const isMobile = window.innerWidth < 768;

      if (
        isMobile &&
        sidebarOpen &&
        sidebarRef.current &&
        !sidebarRef.current.contains(event.target)
      ) {
        closeSidebar();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [sidebarOpen]);

  const logout = async () => {
    const result = await Swal.fire({
      title: "Are you sure?",
      text: "Are you sure you want to logout",
      icon: "question",
      showCancelButton: true,
      confirmButtonText: "Yes, logout!",
      width: "320px",
      customClass: {
        popup: "custom-swal-popup",
        confirmButton: "btn btn-sm btn-danger",
        cancelButton: "btn btn-sm btn-secondary",
      },
    });

    if (result.isConfirmed) {
      setShowLoader(true);
      setTimeout(() => {
        localStorage.removeItem("tk");
        localStorage.removeItem("cn");
        localStorage.removeItem("lo");
        localStorage.removeItem("ut");
        localStorage.removeItem("clientInfo");
        localStorage.removeItem("fn");
        localStorage.removeItem("ln");
        navigate("/admin");
        setShowLoader(false);
      }, 3000);
    }
  };

  return (
    <>
      <Container fluid>
        <button className="mobile-toggle-btn" onClick={toggleSidebar}>
          ☰
        </button>

        <Row className="min-vh-100">
          <Col
            md={3}
            ref={sidebarRef}
            className={`sidebar p-3 shadow-sm d-flex flex-column ${
              sidebarOpen ? "open" : ""
            }`}
          >
            <div className="sidebar-header mb-3 text-center">
              {companyLogo !== "logos/nologo.jpg" ? (
                <img src={getImage(companyLogo)} alt="Logo" height="40" />
              ) : null}
              <h5>
                <div>{companyName}</div>
              </h5>
              <hr style={{ border: "1px solid #2c3e50" }} />
              <p style={{ fontSize: "12px" }}>
                {`Welcome ${userFname} ${userLname}`}{" "}
              </p>
            </div>

            <Nav className="flex-column text-start">
              {userType === 1 ? (
                <>
                  <NavLink
                    to="/admin-createuser"
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <FiUserPlus className="me-2" />
                    Create User
                  </NavLink>
                  <NavLink
                    to="/admin-createclient"
                    className="nav-link text-white "
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <FiUsers className="me-2" />
                    Create Client
                  </NavLink>
                  <NavLink
                    to="/admin-clientuserlink"
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <FiLink className="me-2" />
                    Link Client and User
                  </NavLink>
                  <NavLink
                    to="/admin-message"
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <FaPaperPlane className="me-2" />
                    Send Message
                  </NavLink>
                </>
              ) : (
                <>
                  <NavLink
                    to="/review-data"
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <BsClipboardCheck className="me-2" />
                    Reivew Client Data
                  </NavLink>

                  <NavLink
                    to="/user-message"
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <FaPaperPlane className="me-2" />
                    Message
                  </NavLink>

                  <NavLink
                    to="/print-gen-report"
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <BsPrinter className="me-2" />
                    Print Gen Report
                  </NavLink>
                  <NavLink
                    to={`/client-uploaded-docs`}
                    className="nav-link text-white"
                    style={{ fontWeight: 500 }}
                    onClick={closeSidebar}
                  >
                    <FaBook className="me-2" />
                    Client Documents
                  </NavLink>
                </>
              )}
            </Nav>

            <div className="mt-auto text-center">
              <hr className="text-white" />
              <Nav>
                <NavLink
                  to="/change-password"
                  className="nav-link text-white"
                  style={{ fontWeight: 500 }}
                  onClick={closeSidebar}
                >
                  <BsLock className="me-2" />
                  Change Password
                </NavLink>
                <NavLink
                  className="nav-link-logout text-white"
                  style={{ fontWeight: 500 }}
                  onClick={() => [logout(), closeSidebar()]}
                >
                  <FiLogOut className="me-2" />
                  Logout
                </NavLink>
              </Nav>
              {/* <button className="btn logout-btn text-white w-100 d-flex align-items-center justify-content-center gap-2">
                <BsLock />
                Change Password
              </button>
              <button
                className="btn logout-btn text-white w-100 d-flex align-items-center justify-content-center gap-2"
                onClick={() => logout()}
              >
                <FiLogOut />
                Logout
              </button> */}
            </div>
          </Col>

          {/* Main Content */}
          <Col md={10} className=" content-area">
            <Outlet />
          </Col>
        </Row>
      </Container>
      {showLoader ? <Loader show={showLoader} /> : null}
    </>
  );
};

export default SidebarLayout;
